import { mergeTenderLines } from './posMoney';

const STORAGE_KEY = 'bhima-store.pos-tender-lines';
const MAX_BILLS = 400;

function readMap() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(map) {
  try {
    const entries = Object.entries(map);
    const trimmed = entries.length <= MAX_BILLS
      ? map
      : Object.fromEntries(entries.slice(entries.length - MAX_BILLS));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // Private mode or quota — the open slip still shows the split.
  }
}

/** Remember a cash/UPI/card split so History can reprint both amounts. */
export function savePosTenderLines(orderId, lines) {
  const id = String(orderId || '').trim();
  if (!id || !Array.isArray(lines) || lines.length < 2) return;
  const map = readMap();
  map[id] = lines.map((line) => ({
    method: String(line.method || '').toUpperCase(),
    amount: Number(line.amount) || 0,
  }));
  writeMap(map);
}

export function loadPosTenderLines(orderId) {
  const id = String(orderId || '').trim();
  if (!id) return [];
  const lines = readMap()[id];
  return Array.isArray(lines) ? lines : [];
}

export function withStoredTenderLines(receipt) {
  if (!receipt || typeof receipt !== 'object') return receipt;
  return mergeTenderLines(receipt, loadPosTenderLines(receipt.order_id));
}
